import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-52596641"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "market-cell" };
import OneDeskCountryFlag from "@/components/atoms/OneDeskCountryFlag.vue";
import { computed, onBeforeMount } from "vue";
import { ReferenceValuesTypes } from "@/store/modules/reference-values/types";
import { useStore } from "vuex";
import { AllActionTypes } from "@/store/action-types";
export default /*#__PURE__*/ _defineComponent({
    __name: 'OneDeskMarketColumn',
    props: {
        marketCode: {}
    },
    setup(__props) {
        onBeforeMount(async () => {
            await store.dispatch(AllActionTypes.GET_REFERENCE_VALUES, ReferenceValuesTypes.MARKETS);
        });
        const getMarketLabel = (marketCode) => {
            const market = markets.value.find((market) => market.code === marketCode);
            return market ? market.label : "";
        };
        const store = useStore();
        const props = __props;
        const markets = computed(() => store.getters[ReferenceValuesTypes.MARKETS]);
        const marketLabel = computed(() => getMarketLabel(props.marketCode));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(OneDeskCountryFlag, {
                    class: "market-flag",
                    "market-code": props.marketCode
                }, null, 8, ["market-code"]),
                _createElementVNode("span", null, _toDisplayString(marketLabel.value), 1)
            ]));
        };
    }
});
